import React from "react";
import { createApi } from "../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { createCamerasObject } from "./createCamerasObject";
import { NavigateFunction } from "react-router-dom";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import { useCameraAutoAddStore } from "../CameraAutoAddStore/cameraAutoAddStore";
import { productsMatcher } from "../../../utils/productsMatcher";

export const handleCameraSearchAutoAdd = (
  setCamerasList: any,
  setCamerasObject: any,
  searchString: string,
  navigate: NavigateFunction,
  productsArray: any[],
  setCheckboxesChecked: any,
  checkboxesChecked: any,
  currentSearchRef?: React.MutableRefObject<string>
) => {
  const retryFunction = () => {
    handleCameraSearchAutoAdd(
      setCamerasList,
      setCamerasObject,
      searchString,
      navigate,
      productsArray,
      setCheckboxesChecked,
      checkboxesChecked,
      currentSearchRef
    );
  };

  const {
    setMoreDataToLoadAutoAdd,
    setNvrNextString,
    setSearchingCameras,
    setTotalCamerasPerAPIResponse,
  } = useCameraAutoAddStore.getState();

  // Reset all checkboxesChecked values to false when search is performed
  setCheckboxesChecked((previousState: any) => {
    const resetState: any = {};
    // Set all existing keys to false
    Object.keys(previousState).forEach((key) => {
      resetState[key] = false;
    });
    return resetState;
  });

  const AxiosUI = createApi(``);

  AxiosUI.get(
    `nvr_camera/?customer__id=${localStorage.siteId}&search=${searchString}`
  ).then(
    (response: AxiosResponse) => {
      // Only update state if this response matches the current search term
      if (!currentSearchRef || currentSearchRef.current === searchString) {
        setCamerasList(response.data);
        setTotalCamerasPerAPIResponse(response.data.count);
        setCamerasObject(createCamerasObject(response.data.results));
        setSearchingCameras(false);
        if (response.data.next) {
          setMoreDataToLoadAutoAdd(true);
          setNvrNextString(
            response.data.next.slice(response.data.next.indexOf("?"))
          );
        } else {
          setMoreDataToLoadAutoAdd(false);
        }
        const nvrResults = response.data.results;
        AxiosUI.get(
          `nvr_camera/product/?customer__id=${localStorage.siteId}`
        ).then((response: AxiosResponse) => {
          const productResponse = response.data;
          const idsArray: any = [];
          productResponse.forEach((array: any[]) => {
            idsArray.push(array[1]);
          });
          idsArray.forEach((id: any) => {
            if (productsMatcher("Name", id, productResponse)) {
              const name = productsMatcher("Name", id, productResponse);
              setCheckboxesChecked((previousState: any) => {
                return { ...previousState, [name]: false };
              });
              checkboxesChecked[name] = false;
            }
            nvrResults.forEach((object: any) => {
              if (!object.camera) {
                const name = productsMatcher("Name", id, productResponse);
                const newName = `${name}${object.id}`;
                setCheckboxesChecked((previousState: any) => {
                  return { ...previousState, [newName]: false };
                });
              }
            });
          });
        });
      }
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {});
    }
  );
};
